import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

import { EPaymentSystemStatus, EReviewPaymentSystemActionType } from '../types';

export function getTranslationKeysPendingRequests(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      finance: {
        payment_details_pending_requests: {
          header: 'PENDING_REQUESTS_HEADER',
          download_report: 'DOWNLOAD_REPORT',
          approve: {
            approve_button: `${EReviewPaymentSystemActionType.APPROVE}_BUTTON_LABEL`,
            mass_approve_button: `MASS_${EReviewPaymentSystemActionType.APPROVE}_BUTTON_LABEL`,
            confirm_popup: {
              title: `${EReviewPaymentSystemActionType.APPROVE}_MODAL_TITLE`,
              question: `${EReviewPaymentSystemActionType.APPROVE}_MODAL_QUESTION`,
              ok: `${EReviewPaymentSystemActionType.APPROVE}_MODAL_OK`,
              cancel: `${EReviewPaymentSystemActionType.APPROVE}_MODAL_CANCEL`,
            },
          },
          reject: {
            reject_button: `${EReviewPaymentSystemActionType.REJECT}_BUTTON_LABEL`,
            mass_reject_button: `MASS_${EReviewPaymentSystemActionType.REJECT}_BUTTON_LABEL`,
            confirm_popup: {
              title: `${EReviewPaymentSystemActionType.REJECT}_MODAL_TITLE`,
              question: `${EReviewPaymentSystemActionType.REJECT}_MODAL_QUESTION`,
              reason_label: `${EReviewPaymentSystemActionType.REJECT}_MODAL_REASON_LABEL`,
              ok: `${EReviewPaymentSystemActionType.REJECT}_MODAL_OK`,
              cancel: `${EReviewPaymentSystemActionType.REJECT}_MODAL_CANCEL`,
            },
          },
          review: {
            header: 'REVIEW_MODAL_HEADER',
            new_payment_method_column_title: 'REVIEW_MODAL_LEFT_COLUMN_TITLE',
            old_payment_method_column_title: 'REVIEW_MODAL_RIGHT_COLUMN_TITLE',
            affiliate_contacts_button: 'CONTACTS_BUTTON',
            rejection_reason: 'REVIEW_REJECTION_REASON',
            there_is_no_old_payment_system_details: 'THERE_IS_NO_OLD_PAYMENT_SYSTEM_DETAILS',
            request_tab_name: 'REVIEW_TAB_NAME',
            affiliate_contacts: {
              whatsapp: 'CONTACTS_WHATSAPP',
              telegram: 'CONTACTS_TELEGRAM',
              email: 'CONTACTS_EMAIL',
              ms_teams: 'CONTACTS_MS_TEAMS',
            },
            form: {
              payment_system_name_label: 'FORM_PAYMENT_SYSTEM_NAME_LABEL',
              make_form_editable_button: 'FORM_MAKE_FORM_EDITABLE_BUTTON',
              save_button: 'FORM_SAVE_BUTTON',
              cancel_changes_button: 'FORM_CANCEL_CHANGES_BUTTON',
            },
          },
        },
      },
    },
  }));
}

export function getTranslationKeysRequestsHistory(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      finance: {
        payment_details_requests_history: {
          header: 'REQUESTS_HISTORY_HEADER',
          download_report: 'DOWNLOAD_REPORT',
        },
      },
    },
  }));
}

export function getAffiliatePaymentSystemsTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      profile_settings: {
        tabs: {
          payment_systems: {
            no_payment_system_configured: 'NO_PAYMENT_SYSTEM_CONFIGURED',
            payment_system_statuses: {
              approved: `PAYMENT_SYSTEMS_STATUS.${EPaymentSystemStatus.APPROVED}`,
              pending: `PAYMENT_SYSTEMS_STATUS.${EPaymentSystemStatus.PENDING}`,
              rejected: `PAYMENT_SYSTEMS_STATUS.${EPaymentSystemStatus.REJECTED}`,
            },
            cancel_button: 'CANCEL_BUTTON',
            edit_button: 'EDIT_BUTTON',
            manager_contacts_button: 'CONTACTS_BUTTON',
            manager_contacts: {
              whatsapp: 'CONTACTS_WHATSAPP',
              telegram: 'CONTACTS_TELEGRAM',
              email: 'CONTACTS_EMAIL',
              ms_teams: 'CONTACTS_MS_TEAMS',
            },
            confirm_canceling: {
              header: 'CONFIRM_CANCELING_HEADER',
              message: 'CONFIRM_CANCELING_MESSAGE',
              yes: 'CONFIRM_CANCELING_YES',
              no: 'CONFIRM_CANCELING_NO',
            },
            configure_payment_method_button: 'CONFIGURE_PAYMENT_METHOD_BUTTON',
            settings_payment_system_modal: {
              header: 'SETTINGS_MODAL_HEADER',
              payment_methods_column_title: 'SETTINGS_MODAL_LEFT_COLUMN_TITLE',
              form_column_title: 'SETTINGS_MODAL_RIGHT_COLUMN_TITLE',
              save_button: 'SETTINGS_MODAL_SAVE',
              close_button: 'SETTINGS_MODAL_CLOSE',
            },
          },
        },
      },
    },
  }));
}
